import { render, staticRenderFns } from "./Noteonstudent.vue?vue&type=template&id=16f70cfa"
import script from "./Noteonstudent.vue?vue&type=script&lang=js"
export * from "./Noteonstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports